const getMissingDocumentsStatus = {
  true: 'MISSING EMPLOYEE DOCUMENTS: ',
  false: 'MISSING COMPANY DOCUMENTS: '
};

export default getMissingDocumentsStatus;
